module.exports = __webpack_public_path__ + "media/images/In-2C-41px-TM-1a1da3b5.png";